export class ConfirmationController {

    constructor() {
    }

    $onInit() {
        this.requestSubmittedDate = new Date();
    }

    trackingId: number;
    city: string;
    pickupAddressLine1: string;
    requestSubmittedDate: Date;
    isLoading: boolean;
    orderNumber: number;
    deliveryNumber: number;
    sapErrorMessage: string;

    getFormattedDate(dateValuetobeFormatted: Date): string {

        if (dateValuetobeFormatted !== undefined && dateValuetobeFormatted !== null) {
            var monthValue = dateValuetobeFormatted.getMonth() + 1;
            var dateValue = dateValuetobeFormatted.getDate();
            var yearValue = dateValuetobeFormatted.getFullYear();
            return monthValue + "/" + dateValue + "/" + yearValue;
        }
        return "";
    }

    isMailCenterDarwinBuilding(): boolean {
        if (this.city.toLowerCase() === 'johnston' && this.pickupAddressLine1.toLowerCase() === 'Mail Center Darwin Building #42'.toLowerCase()) {
            return true;
        }

        return false;
    }

    isMcClintockBuilding(): boolean {
        if (this.city.toLowerCase() === 'johnston' && this.pickupAddressLine1.toLowerCase() === 'McClintock Building #40'.toLowerCase()) {
            return true;
        }

        return false;
    }

    messageOption1: boolean = false;
    messageOption2: boolean = false;
    messageOption3: boolean = false;

    pickupCountry: string;
    destinationCountry: string;
    transportationMode: string;
    packageType: string;
    totalShippingCost: number;
    isPackageSizeGreater: boolean;

    ShippingRuleConfirmationMessage(): boolean {
        if (this.city.toLowerCase() === 'johnston') {
            if (this.pickupCountry.toLowerCase() === 'us' && this.destinationCountry.toLowerCase() === 'us') {
                return this.messageOption1 = true;
            }
            //else if (this.transportationMode.toLowerCase() === 'air' || this.transportationMode.toLowerCase() === 'ocean' || this.transportationMode.toLowerCase() === 'truck') {
            //    return this.messageOption2 = true;
            //}
            else if (this.packageType.toLowerCase() === 'envelope') {
                return this.messageOption1 = true;;
            }
            else if (this.destinationCountry.toLowerCase() === 'ca') {
                return this.messageOption1 = true;
            }
            else if ((this.destinationCountry.toLowerCase() === 'br' || this.destinationCountry.toLowerCase() === 'ar')
                || (this.destinationCountry.toLowerCase() === 'cl' && this.totalShippingCost >= 1500)
                || (this.destinationCountry.toLowerCase() === 'pk' && this.totalShippingCost >= 200)
                || (!(this.destinationCountry.toLowerCase() === 'ca' || this.destinationCountry.toLowerCase() === 'br' || this.destinationCountry.toLowerCase() === 'ar' || this.destinationCountry.toLowerCase() === 'cl' || this.destinationCountry.toLowerCase() === 'pk') && this.totalShippingCost >= 2500)) {
                return this.messageOption2 = true;
            }
            else if (this.isPackageSizeGreater) {
                return this.messageOption2 = true;
            }
            else if (this.isPackageSizeGreater === false) {
                return this.messageOption1 = true;
            }
            else {
                return this.messageOption3 = true;
            }
        }
        else {
            return this.messageOption3 = true;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/confirmation/controllers/confirmationController.ts
 **/